import controller from './my-payments-detail.controller';
import template from './my-payments-detail.view.html';

let MyPaymentsDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MyPaymentsDetailComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.component.js
 **/